var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWarningWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5523 4.52001L2.72938 19.2492C2.54747 19.5642 2.45122 19.9214 2.4502 20.2851C2.44918 20.6489 2.54343 21.0066 2.72358 21.3226C2.90372 21.6387 3.16347 21.902 3.47699 22.0865C3.79052 22.271 4.14688 22.3702 4.51063 22.3742H22.1565C22.5202 22.3702 22.8766 22.271 23.1901 22.0865C23.5036 21.902 23.7634 21.6387 23.9435 21.3226C24.1237 21.0066 24.2179 20.6489 24.2169 20.2851C24.2159 19.9214 24.1196 19.5642 23.9377 19.2492L15.1148 4.52001C14.9291 4.21387 14.6676 3.96076 14.3556 3.7851C14.0436 3.60943 13.6916 3.51715 13.3335 3.51715C12.9755 3.51715 12.6235 3.60943 12.3115 3.7851C11.9995 3.96076 11.738 4.21387 11.5523 4.52001V4.52001Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 9.875V14.0417",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 18.2083H13.3448",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarningWhite);
export default __webpack_public_path__ + "static/media/icon-warning-white.df2cc7c1f790b9be49c66f57b6d90fa6.svg";
export { ForwardRef as ReactComponent };